import { Plugins } from '@leverege/plugin';
import { ItemModel } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import DataViewerModelUpdaterCreator from "../DataViewerModelUpdaterCreator.js";
import DetailsView from "./DetailsView.js";
const {
  tf,
  tfIcon
} = I18N.ns('molten.dataViewers.details.DetailsDataViewer');
export default {
  id: 'molten.dataViewer.details.DetailsDataViewer',
  type: 'molten.Details',
  name: tf('name'),
  icon: tfIcon('icon'),
  location: ['main', 'card'],
  matches: {
    type: 'ItemInfoDataViewer'
  },
  settingsUpdaters: DataViewerModelUpdaterCreator.create('DetailsViewModelUpdater'),
  createSettings: props => {
    const {
      objectType
    } = props;
    let mdl = ItemModel.create();
    const dataSources = Plugins.get('DataSource');
    const isArray = Array.isArray(objectType);
    for (let n = 0; n < dataSources.length; n++) {
      const ds = dataSources[n];
      const isType = isArray ? objectType.includes(ds.type) : ds.type === objectType;
      if (isType && ItemModel.getType(mdl, ds.type) == null) {
        mdl = ItemModel.addType(mdl, ds.type);
      }
    }
    return mdl;
  },
  component: DetailsView,
  getDefaultCardContentOptions: {
    height: 'auto'
  },
  getDefaultCardOptions: {
    width: 1
  }
};